import React from 'react'
import { Outlet } from 'react-router-dom'
import { WebBeacon } from '@wow/web-beacon'
import ReferralProvider from 'providers/referralsProvider/ReferralProvider'
import HeaderOffRoad from 'components/headerOffRoad/HeaderOffRoad'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

const Referral = () => {
  const webBeaconSrc = process.env.REACT_APP_WEB_BEACON_IMAGE
  return (
    <ReferralProvider>
      <WebBeacon src={webBeaconSrc} id='id-web-beacon' />
      <HeaderOffRoad />
      <GoogleReCaptchaProvider language="es-AR" reCaptchaKey={process.env.GOOGLE_RECAPTCHA_SITE_KEY}>
      <Outlet />
      </GoogleReCaptchaProvider>    
    </ReferralProvider>
  )
}

export default Referral
